import { Paper, TablePagination } from '@mui/material';
import Grid from '@mui/material/Grid';
import MDButton from '@components/MDButton';
import { useMaterialUIController } from 'context';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LeadStatusService } from './services/lead-status.service';
import { LeadStatusResponse } from './services/responses/lead-status.response';
import { LeadStatusHook } from './hooks/lead-status.hook';
import { NameFilter } from '@components/NameFilter';
import { LeadStatusTable } from './components/lead-status.table';
import { LeadStatusModal } from './components/lead-status.modal';

/// Aba Status do lead da tela Configurações gerais.
export const LeadStatusPanel = () => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const { sidenavColor } = controller;
    const service = new LeadStatusService();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [orderDirection, setOrderDirection] = useState<'desc' | 'asc'>('asc');
    const [nameFilter, setNameFilter] = useState('');
    const [filterFinal, setFilterFinal] = useState('');
    const [refresh, setRefresh] = useState(true);
    const [total, setTotal] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [editItem, setEditItem] = useState<LeadStatusResponse | null>(null);

    const { json } = new LeadStatusHook({
        page,
        limit: rowsPerPage,
        orderBy: 'Name',
        orderDirection,
        filter: filterFinal,
        refresh,
        service,
    }).getJson();

    useEffect(() => {
        setTotal(json?.data?.totalItens ?? 0);
    }, [json]);

    const searchFilter = () => {
        const params: Record<string, string> = {};
        if (nameFilter) params['Name'] = nameFilter;
        const qs = new URLSearchParams(params).toString();
        setPage(0);
        setFilterFinal(qs ? `?${qs}` : '');
    };

    const clearSearch = () => {
        setNameFilter('');
        setFilterFinal('');
        setRefresh((p) => !p);
    };

    const getAll = () => setRefresh((p) => !p);

    const handleOrderList = () => {
        setOrderDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    };

    const handleModal = () => {
        if (openModal) setEditItem(null);
        setOpenModal((p) => !p);
    };

    const getById = async (id: string) => {
        const res = await service.getById(id);
        setEditItem(res.data.data);
        setOpenModal(true);
    };

    return (
        <>
            <Grid container spacing={1}>
                <NameFilter
                    nameFilter={nameFilter}
                    setNameFilter={setNameFilter}
                    onSearch={searchFilter}
                    onClear={clearSearch}
                    onEnter={(e) => e.key === 'Enter' && searchFilter()}
                />
                <Grid size={{ xs: 12, md: 2 }} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <MDButton
                        variant="gradient"
                        color={sidenavColor}
                        onClick={handleModal}
                        sx={{ height: 40, minWidth: 130, whiteSpace: 'nowrap' }}
                    >
                        {t('general.adicionar')}
                    </MDButton>
                </Grid>
            </Grid>
            <Paper sx={{ width: '100%', overflow: 'hidden', mt: 2 }}>
                <LeadStatusTable
                    data={json}
                    editAction={getById}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    orderDirection={orderDirection}
                    handleOrderList={handleOrderList}
                />
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    labelRowsPerPage={t('general.linhasPorPagina')}
                    labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} ${t('general.X-de-X')} ${count !== -1 ? count : `${t('general.maisQue')} ${to}`}`
                    }
                    component="div"
                    count={total}
                    page={page}
                    onPageChange={(_, p) => setPage(p)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value)); setPage(0); }}
                />
            </Paper>
            <LeadStatusModal
                open={openModal}
                edit={editItem}
                handleModal={handleModal}
                getAll={getAll}
                clearSearch={clearSearch}
            />
        </>
    );
};
